export default __webpack_public_path__ + "static/media/005-laptop.c261ee3f.svg";